import { AdminPanel } from './AdminPanel';
import { Toaster } from 'sonner';

const AdminPage = () => {
  return (
    <div data-testid="admin-page" translate="no" className="notranslate min-h-screen bg-slate-50 dark:bg-[#0a0f1a]">
      {/* Header */}
      <header className="bg-white dark:bg-[#151B2B] border-b border-slate-200 dark:border-slate-700 px-4 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-[#1D1D1B] dark:text-white">
              Club<span className="text-[#45A0EE]">Viajemos</span>
            </span>
            <span className="text-slate-300 dark:text-slate-600">|</span>
            <span className="text-sm text-slate-500 dark:text-slate-400">Panel de Administración</span>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="/consolidacion.html"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="admin-consolidacion-link"
              className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-white bg-[#45A0EE] hover:bg-[#3590de] px-4 py-2 rounded-full transition-colors"
            >
              Consolidación
            </a>
            <a href="/" className="text-xs text-[#45A0EE] hover:underline">
              Ir al Dashboard
            </a>
          </div>
        </div>
      </header>

      {/* Admin Content */}
      <main className="max-w-4xl mx-auto px-4 py-6">
        <AdminPanel
          isOpen={true}
          onClose={() => {}}
          skipAuth={false}
          renderMode="page"
        />
      </main>

      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            color: '#1D1D1B',
          },
        }}
      />
    </div>
  );
};

export default AdminPage;
